"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isType(value) {
    return typeof value === "object" && value && value.isType === true;
}
exports.isType = isType;
var Type = (function () {
    function Type(name) {
        this.isType = true;
        this.name = name;
    }
    Type.prototype.is = function (value) {
        return this.validate(value, [{ path: "", type: this }]).length === 0;
    };
    Object.defineProperty(Type.prototype, "Type", {
        get: function () {
            return utils_1.fail("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "SnapshotType", {
        get: function () {
            return utils_1.fail("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: true,
        configurable: true
    });
    return Type;
}());
exports.Type = Type;
var utils_1 = require("../utils");
//# sourceMappingURL=type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/type.js
// module id = 14
// module chunks = 0